import { DEFAULT_ENV, DEPLOY_ENVS } from './env'
import type { DeployEnv } from './env'

export type KitchensinkConfig = {
  tenantSubdomain: string
  tenantId: string
  env: DeployEnv
  autoInit: boolean
}

export type ConfigParamKey = 'tenantSubdomain' | 'tenantId' | 'env' | 'autoinit'

const isDeployEnv = (value: string): value is DeployEnv =>
  (DEPLOY_ENVS as readonly string[]).includes(value)

/**
 * Reads the kitchensink configuration from a query string. Config lives in the URL so
 * setups are bookmarkable/shareable and survive full page loads (the MPA relies on this).
 */
export const readConfig = (search: string): KitchensinkConfig => {
  const params = new URLSearchParams(search)
  const env = params.get('env') ?? ''
  return {
    tenantSubdomain: params.get('tenantSubdomain') ?? '',
    tenantId: params.get('tenantId') ?? '',
    env: isDeployEnv(env) ? env : DEFAULT_ENV,
    autoInit: params.get('autoinit') === '1',
  }
}
